module.exports = __webpack_public_path__ + "img/Slider1.c6330ac8.svg";